// src/hooks/useProductData.js
import { useState, useEffect } from "react";
import { ManageApis } from "../../APIS/ManageApis";
import { HARDCODED_PRODUCTKEY } from "../../constant";
import { handleApiError } from "../../Utils/Utils";

export const useProductData = (showAlert, setLoading) => {
  // Get category from URL hash param if present
  function getCategoryFromHash() {
    const hash = window.location.hash;
    let categoryFromHash = null;
    if (hash.startsWith("#/try/")) {
      const hashParts = hash.replace("#/try/", "").split("?");
      if (hashParts[1]) {
        const params = new URLSearchParams(hashParts[1]);
        categoryFromHash = params.get("category");
      }
    } else if (hash.startsWith("#?")) {
      const params = new URLSearchParams(hash.slice(2));
      categoryFromHash = params.get("category");
    }
    return categoryFromHash;
  }

  const initialCategory = getCategoryFromHash() || "All";
  const [products, setProducts] = useState([]);
  const [subproductscategory, setSubProductscategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(initialCategory);
  const [categoriesFetched, setCategoriesFetched] = useState(false);
  const fetchProducts = async (category = selectedCategory) => {
    console.log("Fetching products for category:", category);
    setLoading(true);
    try {
      let url = `${window.productsList}?productKey=${HARDCODED_PRODUCTKEY}`;
      if (category !== "All") {
        url += `&category=${encodeURIComponent(category)}`;
      }
      const response = await ManageApis("get", url, "", "");
      const { status_code, message } = response || {};
      const {
        status,
        message: responseMessage = "",
        data,
      } = response?.response_data || {};
      if (status_code === 200 && message === "Success") {
        if (status === "Success") {
          setProducts(data);
        } else if (status === "Failed") {
          handleApiError(status, responseMessage, status_code, showAlert);
        } else {
          handleApiError(status, message, status_code, showAlert);
        }
      } else {
        handleApiError(status, message, status_code, showAlert);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setLoading(false);
    }
  };
  const fetchSubproductCategory = async () => {
    try {
      const url = `${window.subProductCategories}?productKey=${HARDCODED_PRODUCTKEY}`;
      const response = await ManageApis("get", url, "", "");
      const { status_code, message } = response || {};
      const {
        status,
        message: responseMessage = "",
        data: categoryData,
      } = response?.response_data || {};

      if (status_code === 200 && message === "Success") {
        if (status === "Success") {
          const sortedData = [...categoryData];
          const allIndex = sortedData.findIndex(
            (cat) => cat.category === "All"
          );

          if (allIndex !== -1) {
            const [allCategory] = sortedData.splice(allIndex, 1);
            sortedData.unshift(allCategory);
            setSubProductscategory(sortedData);
            setCategoriesFetched(true);
            // setSelectedCategory("All");
            // await fetchProducts(selectedCategory);
          } else {
            handleApiError(
              status,
              "No 'All' category found",
              status_code,
              showAlert
            );
          }
        } else if (status === "Failed") {
          handleApiError(status, responseMessage, status_code, showAlert);
        } else {
          handleApiError(status, message, status_code, showAlert);
        }
      } else {
        handleApiError(status, message, status_code, showAlert);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubproductCategory();
  }, []);

  // Sync selectedCategory with hash param if it changes externally
  useEffect(() => {
    const onHashChange = () => {
      const categoryFromHash = getCategoryFromHash();
      if (categoryFromHash && categoryFromHash !== selectedCategory) {
        setSelectedCategory(categoryFromHash);
      }
    };
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, [selectedCategory]);

  useEffect(() => {
    if (categoriesFetched && selectedCategory) {
      fetchProducts(selectedCategory);
    }
  }, [categoriesFetched, selectedCategory]);

  return {
    products,
    subproductscategory,
    selectedCategory,
    setSelectedCategory,
    fetchProducts,
  };
};
